<template lang="html">

  <el-form v-form :model="usedCarLinkForm" :rules="rules" @onSelectInfo="onSelectInfo" addAction="/privateUsedCar/insertUserCarLink.action" selectAction="/privateUsedCar/selectUserCarLinkById.action" editAction="/privateUsedCar/editUserCarLink.action" ref="usedCarLinkForm" style="width:50%" label-width="150px">
    <el-form-item label="渠道名称" prop="linkName" >
      <el-input v-model="usedCarLinkForm.linkName" placeholder="比如巫溪拼车网"></el-input>
    </el-form-item>
    <el-form-item label="所属地区" prop="areaName">
      <search-area-input @onChenged="onAreaChanged" :defaultValue="usedCarLinkForm.areaName" placeholder="请选择市或区县（输入可搜索）">
      </search-area-input>
    </el-form-item>
    <el-form-item label="关联汽车网渠道" prop="channelId">
    <channel-select ref="channel" @change="onChannelChanged" placeholder="请选择（选填）"></channel-select>
  </el-form-item>
    <el-form-item label="对接人姓名" prop="contactsName">
        <el-input v-model="usedCarLinkForm.contactsName" placeholder="请输入负责人姓名"></el-input>
    </el-form-item>
    <el-form-item label="对接人手机" prop="phone">
      <el-input v-model="usedCarLinkForm.phone" placeholder="请输入负责人手机号（用于后台登录）"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary">确定</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import SearchAreaInput from '@/components/SearchAreaInput'
import channelSelect from '@/components/channelSelect'
export default {
  name: 'save-used-car-link',
  components: {
    SearchAreaInput,
    channelSelect
  },
  data () {
    return {
      usedCarLinkForm: {},
      rules: {
        linkName: [
          { required: true, message: '请输入渠道名称', trigger: 'blur' }
        ],
        areaName: [
          { required: true, message: '请选择所属区域', trigger: 'change' }
        ],
        channelId: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入负责人手机号（用于后台登录）', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.usedCarLinkForm.id = this.$route.params.id
  },
  methods: {
    onAreaChanged (addressInfo) {
      this.usedCarLinkForm.areaName = addressInfo.value
    },
    onChannelChanged (channelId) {
      this.usedCarLinkForm.channelId = channelId
    },
    onSelectInfo (formInfo) {
      this.$refs['channel'].settingDefaultChannelInfo({ id: formInfo.datas.channelId, channelName: formInfo.datas.channelName })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
